module.exports = __webpack_public_path__ + "img/13.f2d542c6.svg";